const { SvgIcon } = require('@mui/material');

const PromotionIcon = (props) => (
  <SvgIcon {...props} fill="none">
    <path
      d="M15.9998 12.157V9H12.8428"
      stroke="#1D2023"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19 6L20 5"
      stroke="#1D2023"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 5H5C3.895 5 3 5.895 3 7V19C3 20.105 3.895 21 5 21H18C19.105 21 20 20.105 20 19V14"
      stroke="#1D2023"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M20 9H21.41"
      stroke="#1D2023"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16 4.99984V3.58984"
      stroke="#1D2023"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3 13.62C11 15.417 14.75 10.25 14.75 10.25"
      stroke="#1D2023"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
);

const BusinessIcon = ({ stroke, ...props }) => (
  <SvgIcon {...props} fill="none" style={{ stroke: stroke || 'inherit' }}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5 3H19C20.105 3 21 3.895 21 5V19C21 20.105 20.105 21 19 21H5C3.895 21 3 20.105 3 19V5C3 3.895 3.895 3 5 3Z"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7 17.5V12.5"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.3301 17.5V6.5"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.6602 17.4999V11.3999"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17 17.5V7.5"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
);

const WorldIcon = ({ stroke, ...props }) => (
  <SvgIcon {...props} fill="none" style={{ stroke: stroke || 'inherit' }}>
    <path
      d="M1.5 11.25L3 9.75L4.5 11.25"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M22.5 12.75L21 14.25L19.5 12.75"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.67773 6.79C6.30973 4.501 8.97473 3 11.9997 3C16.9697 3 20.9997 7.03 20.9997 12C20.9997 12.684 20.9167 13.348 20.7727 13.988"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19.3217 6.79004C17.0197 7.56404 14.5627 8.00004 11.9997 8.00004C9.43673 8.00004 6.97973 7.56404 4.67773 6.79004"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19.3181 17.2058C17.6871 19.4948 15.0221 20.9958 11.9961 20.9958C7.02609 20.9958 2.99609 16.9658 2.99609 11.9958C2.99609 11.3118 3.07909 10.6478 3.22309 10.0078"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.6748 17.2061C6.9768 16.4321 9.4338 15.9961 11.9968 15.9961C14.5598 15.9961 17.0168 16.4321 19.3188 17.2061"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 21C14.0711 21 15.75 16.9706 15.75 12C15.75 7.02944 14.0711 3 12 3C9.92893 3 8.25 7.02944 8.25 12C8.25 16.9706 9.92893 21 12 21Z"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
);
const GiftIcon = (props) => (
  <SvgIcon {...props} fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.6666 1.97559L14.2615 1.16142C14.9974 0.785917 15.8872 1.08678 16.2711 1.84354L17.1037 3.48106C17.3237 3.91284 17.7219 4.21485 18.1839 4.29983L19.9328 4.62021C20.7402 4.76835 21.289 5.55726 21.1746 6.40473L20.9261 8.23977C20.8601 8.72437 21.013 9.21356 21.3385 9.56495L22.5727 10.897C23.1424 11.5114 23.1424 12.4875 22.5727 13.103L21.3385 14.435C21.013 14.7864 20.8601 15.2756 20.9261 15.7602L21.1746 17.5953C21.289 18.4427 20.7402 19.2317 19.9328 19.3798L18.1839 19.7002C17.7219 19.7851 17.3237 20.0872 17.1037 20.5189L16.2711 22.1565C15.8872 22.9121 14.9985 23.2141 14.2615 22.8386L12.6666 22.0244C12.2453 21.8097 11.7536 21.8097 11.3323 22.0244L9.73741 22.8386C9.00155 23.2141 8.11169 22.9132 7.72781 22.1565L6.89626 20.5189C6.67627 20.0872 6.27809 19.7851 5.81611 19.7002L4.0672 19.3798C3.25984 19.2317 2.71096 18.4427 2.82536 17.5953L3.07395 15.7602C3.13994 15.2756 2.98705 14.7864 2.66147 14.435L1.42733 13.103C0.857557 12.4886 0.857557 11.5125 1.42733 10.897L2.66147 9.56495C2.98705 9.21356 3.13994 8.72437 3.07395 8.23977L2.82646 6.40473C2.71096 5.5584 3.26094 4.76835 4.0683 4.62136L5.81721 4.30098C6.27809 4.216 6.67627 3.91399 6.89626 3.48221L7.72891 1.84468C8.11279 1.08908 9.00155 0.787065 9.73851 1.16257L11.3334 1.97674C11.7536 2.19148 12.2464 2.19148 12.6666 1.97559Z"
      fill="#EA891D"
      stroke="#EA891D"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.375 16H8.625C8.073 16 7.625 15.552 7.625 15V11.376C7.625 10.824 8.073 10.376 8.625 10.376H15.374C15.926 10.376 16.374 10.824 16.374 11.376V15C16.374 15.552 15.926 16 15.375 16Z"
      stroke="#FDF5EC"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.067 10.3808C12.621 10.3808 13.764 10.2008 14.491 9.44176C15.026 8.88276 15.026 7.97776 14.491 7.41876C13.956 6.85976 13.088 6.85976 12.553 7.41876C11.734 8.27476 12.067 10.3808 12.067 10.3808V10.3808Z"
      stroke="#FDF5EC"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.9327 10.3808C11.3787 10.3808 10.2357 10.2008 9.50867 9.44176C8.97367 8.88276 8.97367 7.97776 9.50867 7.41876C10.0437 6.85976 10.9117 6.85976 11.4467 7.41876C12.2657 8.27476 11.9327 10.3808 11.9327 10.3808V10.3808Z"
      stroke="#FDF5EC"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 10.3799V15.9999"
      stroke="#FDF5EC"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
);
const LogoutIcon = (props) => (
  <SvgIcon {...props} fill="none">
    <path
      d="M15 12H3"
      stroke="#fff"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.94727 16C5.42027 18.961 8.46827 21 12.0003 21C16.9713 21 21.0003 16.971 21.0003 12C21.0003 7.029 16.9713 3 12.0003 3C8.46827 3 5.42027 5.039 3.94727 8"
      stroke="#fff"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 9L15 12L12 15"
      stroke="#fff"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
);
const UserCircleIcon = (props) => (
  <SvgIcon {...props} fill="none">
    <path
      d="M18.3639 5.63604C21.8787 9.15076 21.8787 14.8492 18.3639 18.3639C14.8492 21.8787 9.15074 21.8787 5.63604 18.3639C2.12132 14.8492 2.12132 9.15074 5.63604 5.63604C9.15076 2.12132 14.8492 2.12132 18.3639 5.63604"
      stroke="#1D2023"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17.3074 19.257C16.9234 17.417 14.7054 16 12.0004 16C9.29536 16 7.07736 17.417 6.69336 19.257"
      stroke="#1D2023"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.1213 7.87868C15.2929 9.05025 15.2929 10.9497 14.1213 12.1213C12.9497 13.2929 11.0502 13.2929 9.87868 12.1213C8.70711 10.9497 8.70711 9.05025 9.87868 7.87868C11.0502 6.70711 12.9497 6.70711 14.1213 7.87868"
      stroke="#1D2023"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
);
const InvoiceIcon = (props) => (
  <SvgIcon {...props} fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.5 21H6.5C5.395 21 4.5 20.105 4.5 19V5C4.5 3.895 5.395 3 6.5 3H17.5C18.605 3 19.5 3.895 19.5 5V19C19.5 20.105 18.605 21 17.5 21Z"
      stroke="#1D2023"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14 7.5H16"
      stroke="#1D2023"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14 10.5H16"
      stroke="#1D2023"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8 15H16"
      stroke="#1D2023"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8 18H16"
      stroke="#1D2023"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.5 6.75V6"
      stroke="#1D2023"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.5 11.25V12"
      stroke="#1D2023"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.198 10.714C8.392 11.032 8.724 11.252 9.125 11.252H9.5H9.947C10.529 11.252 11 10.78 11 10.199C11 9.716 10.671 9.295 10.203 9.177L8.797 8.825C8.329 8.707 8 8.286 8 7.803C8 7.222 8.472 6.75 9.053 6.75H9.5H9.875C10.275 6.75 10.606 6.969 10.8 7.286"
      stroke="#1D2023"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
);
const ChevronRightIcon = (props) => (
  <SvgIcon {...props} fill="none">
    <path
      d="M10 16L14 12L10 8"
      stroke="inherit"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
);
const ChevronLeftIcon = (props) => (
  <SvgIcon {...props} fill="none">
    <path
      d="M14 8L10 12L14 16"
      stroke="inherit"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
);
const PDRIcon = ({ stroke, ...props }) => (
  <SvgIcon {...props} fill="none" style={{ stroke: stroke || 'inherit' }}>
    <path
      d="M9.26419 8.73483C9.41064 8.88128 9.41064 9.11872 9.26419 9.26516C9.11774 9.41161 8.88031 9.41161 8.73386 9.26516C8.58741 9.11872 8.58741 8.88128 8.73386 8.73483C8.88031 8.58839 9.11774 8.58839 9.26419 8.73483"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 21V21C7.029 21 3 16.971 3 12V12C3 7.029 7.029 3 12 3V3C16.971 3 21 7.029 21 12V12C21 16.971 16.971 21 12 21Z"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.001 15.9998L15.294 11.7068C15.684 11.3158 16.317 11.3158 16.708 11.7068L20.35 15.3488"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.3482 20.3488L9.70618 14.7068C9.31518 14.3158 8.68218 14.3158 8.29218 14.7068L5.15918 17.8398"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
);

const TokenIcon = ({ stroke, ...props }) => (
  <SvgIcon
    {...props}
    viewBox="0 0 24 24"
    style={{ stroke: stroke || 'currentColor' }}
  >
    <g id="Group">
      <g id="Group_2">
        <path
          id="Union"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.59047 4.4091C8.71254 3.53042 7.28759 3.5301 6.40835 4.40933C5.52925 5.28844 5.52925 6.71256 6.40835 7.59167C7.28746 8.47078 8.71159 8.47078 9.59069 7.59167C10.029 7.15334 10.2488 6.5795 10.25 6.0053C10.25 6.00456 10.25 6.00382 10.25 6.00308C10.25 6.00033 10.25 5.99758 10.25 5.99484C10.2486 5.42092 10.0288 4.84744 9.59069 4.40933L9.59047 4.4091ZM11.674 5.2472C11.532 4.55158 11.1911 3.88842 10.6514 3.34867L10.6511 3.34846C9.18704 1.88358 6.81231 1.88405 5.34769 3.34867C3.8828 4.81356 3.8828 7.18744 5.34769 8.65233C6.81259 10.1172 9.18646 10.1172 10.6514 8.65233C11.1928 8.11087 11.5341 7.44523 11.6753 6.74721L14.25 6.73659V8.604C14.25 9.01821 14.5858 9.354 15 9.354C15.4142 9.354 15.75 9.01821 15.75 8.604V6.7304L18.25 6.72009V8.57101C18.25 8.98522 18.5858 9.32101 19 9.32101C19.4142 9.32101 19.75 8.98522 19.75 8.57101V5.96701C19.75 5.96597 19.75 5.96494 19.75 5.9639C19.7496 5.86148 19.7286 5.7639 19.6911 5.67508C19.5768 5.40483 19.3087 5.21571 18.9969 5.217L11.674 5.2472ZM5.5 14.75C3.98121 14.75 2.75 15.9812 2.75 17.5C2.75 19.0188 3.98121 20.25 5.5 20.25H18.5C20.0188 20.25 21.25 19.0188 21.25 17.5C21.25 15.9812 20.0188 14.75 18.5 14.75H5.5ZM1.25 17.5C1.25 15.1528 3.15279 13.25 5.5 13.25H18.5C20.8472 13.25 22.75 15.1528 22.75 17.5C22.75 19.8472 20.8472 21.75 18.5 21.75H5.5C3.15279 21.75 1.25 19.8472 1.25 17.5ZM17.997 16.4435C18.5852 16.4408 19.0565 16.9174 19.0565 17.499C19.0565 18.0816 18.5859 18.5565 18 18.5565C17.4163 18.5565 16.9435 18.0837 16.9435 17.5C16.9435 16.9173 17.4146 16.4451 17.997 16.4435ZM17.997 16.4435L17.994 16.4435L17.9961 16.725L18 16.7238V16.4435L17.997 16.4435ZM15.0565 17.499C15.0565 16.9174 14.5852 16.4408 13.997 16.4435L14 16.4435V16.7238L13.9961 16.725L13.994 16.4435L13.997 16.4435C13.4146 16.4451 12.9435 16.9173 12.9435 17.5C12.9435 18.0837 13.4163 18.5565 14 18.5565C14.5827 18.5565 15.0565 18.0837 15.0565 17.499ZM9.99699 16.4435C10.5852 16.4408 11.0565 16.9174 11.0565 17.499C11.0565 18.0837 10.5827 18.5565 10 18.5565C9.41627 18.5565 8.9435 18.0837 8.9435 17.5C8.9435 16.9173 9.41464 16.4451 9.99699 16.4435ZM9.99699 16.4435L9.99398 16.4435L9.99607 16.725L10 16.7238V16.4435L9.99699 16.4435ZM7.0565 17.499C7.0565 16.9174 6.58517 16.4408 5.99699 16.4435L6 16.4435V16.7238L5.99607 16.725L5.99398 16.4435L5.99699 16.4435C5.41464 16.4451 4.9435 16.9173 4.9435 17.5C4.9435 18.0837 5.41627 18.5565 6 18.5565C6.58273 18.5565 7.0565 18.0837 7.0565 17.499Z"
          fill="none"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </g>
  </SvgIcon>
);

const ArrowDownIcon = (props) => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    <g id="Group">
      <g id="Group_2">
        <path
          id="Union"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.5303 15.5303C13.2374 15.8232 12.7626 15.8232 12.4697 15.5303C12.1768 15.2374 12.1768 14.7626 12.4697 14.4697L14.1893 12.75H11.419H10C6.27179 12.75 3.25 9.72821 3.25 6V5.92001V4.924V3.00001C3.25 2.5858 3.58579 2.25001 4 2.25001C4.41421 2.25001 4.75 2.5858 4.75 3.00001V4.924V5.92001V6C4.75 8.89979 7.10021 11.25 10 11.25H11.419H14.1893L12.4697 9.53033C12.1768 9.23744 12.1768 8.76256 12.4697 8.46967C12.7626 8.17678 13.2374 8.17678 13.5303 8.46967L16.5303 11.4697C16.6768 11.6161 16.75 11.8081 16.75 12C16.75 12.1017 16.7298 12.1987 16.6931 12.2871C16.6565 12.3755 16.6022 12.4584 16.5303 12.5303L13.5303 15.5303Z"
          fill="currentColor"
        />
      </g>
    </g>
  </SvgIcon>
);

const ArrowRightIcon = (props) => (
  <SvgIcon {...props} viewBox="0 0 20 20">
    <g id="Group">
      <path
        id="Path"
        d="M16.6583 9.98332H4.16666"
        stroke="#01B075"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Path_2"
        d="M11.6559 4.98999L16.665 9.99999L11.6559 15.01"
        stroke="#01B075"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </SvgIcon>
);

const RotateIcon = (props) => (
  <SvgIcon width="24" height="24" viewBox="0 0 24 24" {...props}>
    <path
      d="M13 19H7C5.895 19 5 18.105 5 17V5"
      stroke="#1D2023"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11 5H17C18.105 5 19 5.895 19 7V19"
      stroke="#1D2023"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.5 7.5L5 5L2.5 7.5"
      stroke="#1D2023"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16 16L19 19L22 16"
      stroke="#1D2023"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
);

export {
  PromotionIcon,
  WorldIcon,
  BusinessIcon,
  GiftIcon,
  LogoutIcon,
  UserCircleIcon,
  InvoiceIcon,
  ChevronRightIcon,
  ChevronLeftIcon,
  PDRIcon,
  TokenIcon,
  ArrowDownIcon,
  ArrowRightIcon,
  RotateIcon,
};
